module.exports = __webpack_public_path__ + "static/media/defaultClient.dcee5964.svg";